import axios from '@/api/axios';
import { gql } from '@/api/utils';

export default {
  async determineProductInterrupt(orderId, cityId) {
    try {
      const query = gql`
        query Query($orderId: ID!, $cityId: ID!) {
          determineProductInterrupt(orderId: $orderId) {
            variant: name
            contentExperimentName
            marketingContentImage {
              sort
              image {
                original
              }
              resolution
            }
            marketingContentHtml {
              sort
              html
            }
            marketingContentCarousel {
              sort
              linkName
              productGroup {
                id
                name
                productType
                productStyles(cityId: $cityId) {
                  id
                  code
                  name
                  price
                  description
                  discountedPrice
                  description
                  image {
                    original
                    thumbnail
                  }
                  images {
                    id
                    original
                  }
                  priceRange {
                    min
                    max
                  }
                  productType
                  hasMultipleSKUs
                  productGroups {
                    id
                  }
                  products {
                    id
                    type
                    name
                    status
                    __typename
                    ... on CollarProduct {
                      size
                      color
                      price
                      discountedPrice
                      status
                      image {
                        original
                      }
                      backImage {
                        original
                      }
                      sizeTitle
                      sizeLength
                      sizeWidth
                      sizeDescription
                      sizeImage {
                        original
                      }
                      personalization {
                        price
                      }
                      price
                      discountedPrice
                    }
                  }
                }
              }
            }
          }
        }
      `;

      const { determineProductInterrupt: results } = await axios.post(`/`, { query, variables: { orderId, cityId } });

      return Promise.resolve(results);
    } catch (error) {
      return Promise.reject({
        message: error.message,
      });
    }
  },
  async getPetTrackingDeviceLicensingFlowInterruptContext() {
    try {
      const query = gql`
        query PetTrackingDeviceLicensingFlowInterruptContext {
          petTrackingDeviceLicensingFlowInterruptContext {
            petTrackingDeviceAddToOrderContext {
              startNewOrderItemButtonText
              continueToCheckoutUrl
              continueButtonText
              deleteOrderItemButtonText
              submitNewOrderItemFormButtonText
              cancelNewOrderItemButtonText
              subscriptionOptions {
                label
                productId
                billed
                extras {
                  text
                  color
                  backgroundColor
                }
              }
              petOptions {
                label
                value
              }
              devicesCurrentlyInBasket {
                petName
                orderItemId
                displayPrice
                productLabel
              }
              stepOneText
              stepTwoText
              selectPetText
              selectSubscriptionText
            }
            productInterrupt {
              name
              contentExperimentName
              marketingContentHtml {
                type
                html
                sort
              }
              marketingContentImage {
                type
                sort
                resolution
                alternativeText
                image {
                  id
                  original
                  thumbnail
                  imageAltText
                }
              }
              marketingContentCarousel {
                type
                linkName
              }
              marketingContentPetTrackingDevice {
                type
                sort
              }
            }
            marketingPrice
            addToOrderSectionContext {
              petTrackerDeviceImage
              petTrackerAppImage
              subtitleBottom
              callToActionBody
              skipAndContinueButtonText
              continueButtonText
            }
          }
        }
      `;

      const { petTrackingDeviceLicensingFlowInterruptContext: results } = await axios.post(`/`, { query });

      return Promise.resolve(results);
    } catch (error) {
      return Promise.reject({
        message: error.message,
      });
    }
  },
};
